module.exports = __webpack_public_path__ + "img/mineshaft_thumb.d78b01f5.jpg";